module.exports = __webpack_public_path__ + "img/horizontal_4_1_9016.c6a0ec50.png";